// src/request/constants.ts
var GET_MATCH_RESULT = Symbol();
export {
  GET_MATCH_RESULT
};
